import { useQueryClient } from "@tanstack/react-query";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import { apiInstance } from "shared/api";
import { languages } from "shared/i18n/i18n";
import styles from "./index.module.scss";

export const LanguageSelectBlock = () => {
  const { i18n, t } = useTranslation();
  const queryClient = useQueryClient();

  const onChange = (value: string) => {
    i18n.changeLanguage(value);
    localStorage.setItem("language", value);

    apiInstance.interceptors.request.use((config) => {
      config.headers.set("user-lang", value);
      return config;
    });
    queryClient.invalidateQueries({ queryKey: ["profile"] });
  };

  return (
    <div className={styles.block}>
      <div className={styles.title}>{t("language.block_title")}</div>

      <Select
        style={{ width: "100%" }}
        onChange={onChange}
        value={i18n.language}
        options={Object.values(languages).map((lang) => ({
          value: lang.code,
          label: lang.name,
        }))}
      />
    </div>
  );
};
